import { createGlobalStyle } from "styled-components";
import { fontSansSerif } from "./fonts";
import { normalize } from "polished";
import { grid } from "./grid";

export const GlobalStyle = createGlobalStyle`
  :root {
    /* Equisoft palette. Primary/form colours from Product Design > Color palette
       and usage; button colours match the equisoft.com button system. */
    --primary-color: #0080a5; /* Primary 1.1 - links and clickable elements */
    --primary-hover-color: #005f7a; /* Primary 1.3 */
    --heading-color: #012639; /* Primary 2 */
    --footer-color: #012639; /* Primary 2 */
    --button-color: #ff4338; /* Tertiary - primary call to action */
    --button-disabled-color: #ff9a95; /* Tertiary disabled */
    --button-focus-ring: rgba(255, 67, 56, 0.5);
    --button-outline-disabled-color: #9ca7b4; /* Mid Grey */
    --button-transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    --form-control-color: #0080a5; /* Primary 1.1 */
  }

  *,
  :after,
  :before {
    box-sizing: border-box;
  }

  ${normalize()};

  html {
    font-size: 14px;
    font-family: sans-serif;
  }

  body {
    font-family: ${fontSansSerif};
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #333;
    text-align: left;

    &.noscroll {
      overflow: hidden !important;
    }
  }

  a {
    color: var(--primary-color);
    text-decoration: none;
    cursor: pointer;

    &:hover {
      color: var(--primary-hover-color);
      text-decoration: underline;
    }
  }

  img {
    vertical-align: middle;
    border-style: none;
    max-width: 100%;
  }

  p {
    margin-top: 0;
    margin-bottom: 1rem;
  }

  table {
    border-collapse: collapse;
  }

  th {
    text-align: inherit;
  }

  dl,
  ol,
  ul {
    margin-top: 0;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-top: 0;
    font-family: inherit;
    font-weight: 500;
    line-height: 1.2;
    color: inherit;
  }

  h1 {
    font-size: 2.5rem;
  }
  h2 {
    font-size: 2rem;
  }
  h3 {
    font-size: 1.75rem;
  }
  h4 {
    font-size: 1.5rem;
  }
  h5 {
    font-size: 1.25rem;
  }
  h6 {
    font-size: 1rem;
  }

  hr {
    margin-top: 1rem;
    margin-bottom: 1rem;
    border: 0;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
  }

  label {
    display: inline-block;
    margin-bottom: 0.5rem;
  }

  textarea {
    line-height: 1.4;
    resize: vertical;
  }

  ::placeholder {
    color: #aaa;
    font-size: 0.9em;
  }

  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type="date"]::-webkit-inner-spin-button {
    display: none;
  }

  .hidden {
    display: none !important;
  }

  ${grid};

  .table {
    width: 100%;
  }
  .table thead tr th {
    border-bottom: 1px solid #999;
    text-align: left;
    padding: 8px 12px;
  }
  .table tbody tr td {
    border-bottom: 1px solid #ccc;
    text-align: left;
    padding: 8px 12px;
  }
`;
